<script>
    import { fly } from "svelte/transition";
    import { Card,Button,Arrow,Toast,notify } from "../index";

    function handleClick(){
        notify.show('点击了卡片')
    }
</script>

<div class="example" transition:fly={{ x: 200 }}>
    <h4 class="example-title">基础用法</h4>
    <div class="example-body gray">
        <Card title="卡片标题" on:click={handleClick}>卡片内容</Card>
    </div>
    <h4 class="example-title">没有卡片内容</h4>
    <div class="example-body gray">
        <Card title="卡片标题" on:click={handleClick} />
    </div>
    <h4 class="example-title">没有卡片标题</h4>
    <div class="example-body gray">
        <Card on:click={handleClick}>卡片内容</Card>
    </div>
    <h4 class="example-title">自定义卡片内容</h4>
    <div class="example-body gray">
        <Card title="卡片标题" on:headerClick={()=>notify.show('点击了卡片Header区域')} on:bodyClick={()=>notify.show('点击了卡片Body区域')}>
            卡片内容
            <Arrow slot="extra"/>
            <div class="diy-footer">
                <Button color="primary">底部按钮</Button>
            </div>
        </Card>
    </div>
    <h4 class="example-title">自定义卡片样式</h4>
    <div class="example-body gray">
        <Card title="卡片标题" --sui-card-body-color="green" --sui-card-title-color="#1677ff">
            卡片内容
        </Card>
    </div>
    
</div>

<Toast/>

<style lang="less">
    @import "./example.less";
    .gray {
        background-color: gray;
    }
    .diy-footer {
        margin-top: 12px;
        border-top: .5px solid #eee;
        display: flex;
        justify-content: flex-end;
        padding: 10px 0;
    }
</style>
